/**
 * 主题+租户身份色运行时 helper。
 *
 * - theme: light/dark/system(默认) · 存 localStorage.theme · 应用到 <html data-theme>
 * - tenant color: 按 slug 稳定哈希到 sc/sn/tl 三色调色板 · 应用到 <html data-tenant>
 *
 * mockup 里 3 家公司写死;wms-erp 是 SaaS 多租户 · 任何 slug 都可能出现 ·
 * 用哈希保证同一 slug 永远同色 · 无需业务方配置。
 */
const TENANT_PALETTES = ["sc", "sn", "tl"];
export function applyTheme(choice) {
    const root = document.documentElement;
    if (choice === "system") {
        root.removeAttribute("data-theme");
    }
    else {
        root.setAttribute("data-theme", choice);
    }
    try {
        localStorage.setItem("theme", choice);
    }
    catch { /* private mode */ }
}
export function getStoredTheme() {
    try {
        const v = localStorage.getItem("theme");
        if (v === "light" || v === "dark" || v === "system")
            return v;
    }
    catch { /* ignore */ }
    return "system";
}
export function applyStoredTheme() {
    applyTheme(getStoredTheme());
}
/**
 * slug → 稳定色调色板索引 · djb2 hash。
 * 同一 slug 每次都是同一色 · 不同 slug 均匀分到 sc/sn/tl。
 * 特殊值:"platform"/"global"/"" → global(中性青灰)。
 */
export function tenantColorFor(slug) {
    if (!slug)
        return "global";
    const s = String(slug).trim().toLowerCase();
    if (s === "platform" || s === "global")
        return "global";
    // 显式匹配 · 让业务方直接用 sn/tl 得到期望色
    if (s === "sc" || s === "sanchuan")
        return "sc";
    if (s === "sn" || s === "sinan")
        return "sn";
    if (s === "tl" || s === "tianlai")
        return "tl";
    let h = 5381;
    for (let i = 0; i < s.length; i++)
        h = ((h << 5) + h) + s.charCodeAt(i);
    return TENANT_PALETTES[Math.abs(h) % TENANT_PALETTES.length];
}
export function applyTenantColor(slug) {
    const code = tenantColorFor(slug);
    document.documentElement.setAttribute("data-tenant", code);
}
export function applyStoredTenantColor() {
    try {
        const raw = localStorage.getItem("tenant");
        if (!raw)
            return;
        const t = JSON.parse(raw);
        applyTenantColor(t?.slug);
    }
    catch { /* invalid stored tenant · leave default */ }
}
//# sourceMappingURL=theme-runtime.js.map